Vue.component('star-distribution-chart', {
    props: ['stars'],
    template:`
        <canvas v-if="hasData" ref="star_distribution_chart" width="350" height="390"></canvas>`,

    watch: {

        stars: function(newValue, oldValue) {
            this.updateChart()
        }

    },

    data() {
        return {
            chart: null,
            activeLegends: [],
            disabledChannels: []
        }
    },
    mounted() {
        
        let area = this.$refs.star_distribution_chart;

        this.chart = new Chart(area, {
            type: 'bar',
            data: {
                labels: [],
                datasets: [{
                    label: 'Average Rating',
                    data: [],
                    backgroundColor:["#00afef", "#8b72f5","#0153b9", '#44d4d2', '#FF307C']
                }]
            },
            options: {
                legend: {
                    display: false,
                },
                tooltips: {
                    callbacks: {
                      label: function(tooltipItem, data) {
                        var dataset = data.datasets[tooltipItem.datasetIndex];
                        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                        var total = meta.total;
                        var currentValue = dataset.data[tooltipItem.index];
                        var percentage = parseFloat((currentValue/total*100).toFixed(1));
                        return currentValue;// + ' (' + percentage + '%)';
                      },
                      title: function(tooltipItem, data) {
                        return data.labels[tooltipItem[0].index];
                      }
                    }
                }
            }
        });
    },

    methods: {
        updateChart() {

            this.activeLegends = [];
            
            let star = String.fromCharCode(0x2605)

            this.chart.data.labels = ['1' + star, '2' + star, '3' + star, '4' + star, '5' + star];
            this.chart.data.datasets[0].data = this.stars;
            this.chart.update();

        },
        hasData() {
            return this.stars != [0, 0, 0, 0, 0]
        }
    }
});